import "./home-nav-item.styles.scss";

import IconNavList from '../../assets/icons/nav-list.svg';
import IconRightArrow from '../../assets/icons/right-arrow.svg';
import { Link } from "react-router-dom";

const HomeNavItem = ({
    navItem
}) => {
    const Icon = navItem.icon && navItem.icon;
    return (
        <div className="home-nav-item">
            <div className="home-nav-item__header">
                <span className="home-nav-item__header__icon">
                   {Icon && <Icon className="home-nav-item__header__icon__item"/>}
                </span>
               
                <span className="home-nav-item__header__title">
                    {navItem.title}
                </span>
            </div>
            <ul className="home-nav-item__body">
                {
                    navItem.items.map(item => {
                        return (
                            <li className="home-nav-item__body__item">
                                <Link
                                    to={item.page}
                                    className="home-nav-item__body__item__link"
                                >
                                    {item.text}
                                    <img src={IconRightArrow} />
                                </Link>
                            </li>
                        )
                    })
                }
            </ul>
        </div>
    )
}

export default HomeNavItem;